<template>
  <Page data-cy="page" title="Financing">
    <TabSwitcher data-cy="tabSwitcher" :tabs="tabs" />
  </Page>
</template>

<script setup lang="ts">
import { computed } from "vue";

import Page from "@/components/Page.vue";
import TabSwitcher from "@/components/TabSwitcher/TabSwitcher.vue";
import ManagePrograms from "./ManagePrograms/ManagePrograms.vue";
import { LendersList } from "./types";

const props = defineProps({
  loanProgramFilters: {
    type: Array,
    default: () => []
  },
  departmentOptions: {
    type: Array,
    required: true
  }
});

const tabs = computed(() => {
  return LendersList.map((lender) => ({
    name: lender.name,
    component: ManagePrograms,
    props: {
      lender: lender.key,
      lenderLogo: lender.logo,
      filters: props.loanProgramFilters,
      departmentOptions: props.departmentOptions
    }
  }));
});
</script>
